@if (!(action.disabled && action.definition.hideOnDisabled)) {
	<button [disabled]="action.disabled" [matTooltipDisabled]="!action.disabled" [matTooltip]="action.message | translate" mat-menu-item (click)="emitSelectAction(action.definition)">
		<span>{{ action.definition.title | translate }}</span>
	</button>
}
